import { FaInstagram, FaFacebook, FaTwitter, FaLinkedin } from 'react-icons/fa';

export const footerLinks = [
    {
      title: "Useful Links",
      links: [
        {
          name: "How it Works",
          link: "https://www.Estateland.com/how-it-works/",
        },
        {
          name: "Content",
          link: "https://www.Estateland.com/content/",
        },
        {
          name: "Explore",
          link: "https://www.Estateland.com/explore/",
        },
        {
          name: "Terms",
          link: "https://www.Estateland.com/terms-and-services/",
        },
      ],
    },
    {
      title: "Partner",
      links: [
        {
          name: "Partners",
          link: "https://www.Estateland.com/our-partner/",
        },
        {
          name: "Contact",
          link: "https://www.Estateland.com/become-a-partner/",
        },
        {
          name: "Types",
        },
        {
          name: "Ways",
        },
      ],
    },
    {
      title: "Community",
      links: [
        {
          name: "Newsletters",
          link: "https://www.Estateland.com/newsletters/",
        },
        {
          name: "Help Center",
          link: "https://www.Estateland.com/help-center/",
        },
        {
          name: "Partners",
          link: "https://www.Estateland.com/partners/",
        },
        {
          name: "Blog",
          link: "https://www.Estateland.com/blog/",
        },
      ],
    },
  ];
  
  export const socialMedia = [
    {
      id: "social-media-1",
      icon: <FaInstagram />,
      link: "https://www.instagram.com/",
    },
    {
      id: "social-media-2",
      icon: <FaFacebook />,
      link: "https://www.facebook.com/",
    },
    {
      id: "social-media-3",
      icon: <FaTwitter />,
      link: "https://www.twitter.com/",
    },
    {
      id: "social-media-4",
      icon: <FaLinkedin />,
      link: "https://www.linkedin.com/",
    },
  ];